import {createStyles, makeStyles, Theme} from '@material-ui/core';
import {LIGHT_GRAY, PRIMARY_RED} from '../../../../const/colors';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        avatar: {
            width: theme.spacing(6),
            height: theme.spacing(6),
        },
        selectedAvatar: {
            border: '2px solid',
            borderColor: theme.palette.secondary.main,
        },
        name: {
            marginLeft: theme.spacing(2),
            [theme.breakpoints.down('sm')]: {
                marginLeft: 16,
            },
        },
        container: {
            cursor: 'pointer',
            borderBottom: `1px solid ${LIGHT_GRAY}`,
            [theme.breakpoints.up('md')]: {
                paddingLeft: theme.spacing(2),
                paddingRight: theme.spacing(2),
            },
        },
        listItem: {
            [theme.breakpoints.down('sm')]: {
                paddingBottom: 30,
            },
        },
        timeBox: {
            minWidth: 90,
            height: 45,
            borderRadius: 2,
            alignItems: 'center',
            display: 'flex',
            padding: '0 6px',
            flexDirection: 'column',
            justifyContent: 'center',
            backgroundColor: LIGHT_GRAY,
            [theme.breakpoints.down('sm')]: {
                flexDirection: 'row',
                justifyContent: 'space-between',
                marginBottom: 24,
                width: '100%',
            },
        },
        ratingWrapper: {
            display: 'flex',
            alignItems: 'center',
        },
        ratingText: {
            fontSize: 14,
            color: theme.palette.text.secondary,
            marginLeft: 10,
        },
        timeslotWrapper: {
            display: 'flex',
            alignItems: 'center',
            flex: 1,
            flexDirection: 'column',
            padding: '8px 0',
        },
        dayNameWrapper: {
            fontSize: 12,
            textAlign: 'center',
        },
        timeWrapper: {
            fontSize: 16,
            fontWeight: 'bold',
            textAlign: 'center',
            color: theme.palette.secondary.main,
        },
        medicInfoWrapper: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
        },
        bookButtonWrapper: {
            width: '100%',
            display: 'flex',
            alignItems: 'flex-end',
            justifyContent: 'flex-end',
        },
        PRIMARY_REDBackground: {
            backgroundColor: PRIMARY_RED,
        },
        whiteFont: {
            color: 'white',
        },
        [theme.breakpoints.up('md')]: {
            timeslotWrapper: {
                flexDirection: 'row',
            },
            medicInfoWrapper: {
                marginLeft: 32,
                marginRight: 40,
            },
        },
    }),
);

export default useStyles;
